export default __webpack_public_path__ + "static/media/optical.c92d09fb.png";